/* LB 24-09-2026 — header tipo app (toda la web).
   Problema que tenía Ayoub: al hacer scroll despacio el header se iba con la página y no volvía; al hacerlo fuerte sí.
   Causa: el JS grande del tema pone la clase body.lb-page-scrolled (header fijo + fondo blanco borroso) solo cuando
   cambia algo en el DOM (MutationObserver), porque su escucha de scroll nunca llega a engancharse (ReferenceError de
   bindInlineCardSwatchBridge). Resultado: comportamiento aleatorio.
   Aquí:
   1) lb-page-scrolled se pone/quita en CADA scroll (fiable).
   2) Comportamiento más usado en tiendas dropshipping / temas Shopify ("sticky on scroll up"): al bajar, el header se
      recoge hacia arriba de forma fluida y deja toda la pantalla al producto; en cuanto el cliente sube un poco, vuelve.
      Arriba del todo se queda el header original (transparente sobre la imagen). No se recoge si hay menú, buscador o
      carrito abiertos. CSS en assets/lb-header-24-09.css (body.lb-header-hidden). */
(function () {
  'use strict';
  /* 24-09 noche (Ayoub): el header NO debe recogerse. Lo que quería es que, cuando el navegador del móvil esconde su
     barra de dirección al bajar, el header (con el logo) ocupe ese hueco de forma fluida y se quede siempre visible.
     Eso lo da el header fijo (lb-page-scrolled fiable). HIDE_ON_SCROLL=false deja apagado el recogido. */
  var HIDE_ON_SCROLL = false;
  var HIDE_AFTER = 140;   // px de scroll antes de poder recoger el header
  var DOWN_DELTA = 10;    // px bajando seguidos para recogerlo
  var UP_DELTA = 6;       // px subiendo para mostrarlo
  var lastY = window.scrollY || 0;
  var acc = 0;
  var ticking = false;
  var lastH = 0;

  function setClass(el, name, on) { // solo toca el DOM si cambia (evita bucles con el MutationObserver)
    if (el.classList.contains(name) !== !!on) el.classList.toggle(name, !!on);
  }

  function overlayOpen() {
    var b = document.body.classList;
    if (b.contains('lb-drawer-open') || b.contains('lb-search-open') || b.contains('lb-custom-search-open') ||
        b.contains('lb-top-cart-open') || b.contains('lb-cart-drawer-open') || b.contains('lb-facets-open')) return true;
    return !!document.querySelector('#Details-menu-drawer-container[open], details-modal[open], .lb-top-cart-panel.is-visible, cart-drawer.active, .mobile-facets__disclosure[open]');
  }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY || 0);
    var body = document.body;
    var scrolled = y > 0;
    var ov = overlayOpen();
    setClass(body, 'lb-page-scrolled', scrolled || ov);
    Array.prototype.forEach.call(document.querySelectorAll('sticky-header.header-wrapper, .header-wrapper'), function (h) {
      setClass(h, 'lb-scrolled', scrolled || ov);
    });
    /* 25-09: fichas con header blanco fijo (lb-cabecera-blanca): altura real del header para el padding del main */
    var hg = document.querySelector('.shopify-section-group-header-group, .section-header');
    if (hg && body.classList.contains('lb-cabecera-blanca')) {
      var hh = Math.round(hg.getBoundingClientRect().height);
      if (hh > 0 && hh !== lastH) { lastH = hh; document.documentElement.style.setProperty('--lb-hdr-h', hh + 'px'); }
    }
    var delta = y - lastY;
    lastY = y;
    if (!HIDE_ON_SCROLL || ov || y <= HIDE_AFTER) { setClass(body, 'lb-header-hidden', false); acc = 0; return; }
    if ((delta > 0 && acc < 0) || (delta < 0 && acc > 0)) acc = 0; // cambio de sentido
    acc += delta;
    if (acc > DOWN_DELTA) setClass(body, 'lb-header-hidden', true);
    else if (acc < -UP_DELTA) setClass(body, 'lb-header-hidden', false);
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.setTimeout(update, 16); } // setTimeout y no rAF: rAF se para si la pestaña no pinta
  }

  function init() {
    document.body.classList.add('lb-header-app');
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* 24-09 noche (Ayoub: "la primera vez no funciona"): red de seguridad: se revisa también al tocar/mover y cada 200 ms,
       por si el navegador del móvil retrasa o se traga el evento scroll */
    window.addEventListener('touchmove', onScroll, { passive: true });
    window.addEventListener('touchend', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.setInterval(update, 200);
    // si se abre menú/buscador/carrito, mostrar el header al momento
    if (window.MutationObserver) {
      new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
